import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactSocial.scss";


import InstagramIcon from "./../../assets/contact/icons8-instagram2.svg";
import TwitterIcons from "./../../assets/contact/icons8-twitter1.svg";
import GmailIcon from "./../../assets/contact/icons8-gmail.svg";
import LinkedInIcon from "./../../assets/contact/icons8-linkedin.svg";



const ContactSocial = () => (
  <div id="ContactSocial">
  <Row >
    <Col xs={12}>
      <Row center="xs">
        <Col xs={12} lg={1} className="contact__social">
        <div><a href='https://www.linkedin.com/in/sachin-mishra-a9a935145/'>
          <img src={LinkedInIcon} alt="LinkedIn"  />
          </a>
          </div>
        </Col>
        <Col xs={12} lg={1} className="contact__social">
        <div><a href='https://twitter.com/sachin042295'>
          <img src={TwitterIcons} alt="Twitter" />
          </a>
          </div>
        </Col>
        <Col xs={12} lg={1} className="contact__social">
          <div><a href="https://www.instagram.com/sachin.mm22/"><img src={InstagramIcon} alt="Instagram" />
          </a>
          </div>
        </Col>
        
      </Row>
    </Col>
  </Row>
  </div>
);

export default ContactSocial;
